import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames,
  getSubscriptionPlanModulesAPI,
  addSubscriptionPlanModuleAPI,
  updateSubscriptionPlanModuleAPI,
  deleteSubscriptionPlanModuleAPI,
  activateDeactivateSubscriptionPlanModuleAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Subscription Table Column Names
export const fetchSubscriptionPlanModuleTableColumns = createAsyncThunk(
  "subscriptionPlanModule/fetchSubscriptionPlanModuleTableColumns",
  async (subscription, thunkAPI) => {
    try {
      const response = await getTableColumnNames(subscription);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch Subscription
export const fetchAllSubscriptionPlanModules = createAsyncThunk(
  "subscriptionPlanModule/fetchSubscriptionPlanModules",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSubscriptionPlanModulesAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching subscription plan modules");
    }
  }
);

// Add Subscription
export const addSubscriptionPlanModule = createAsyncThunk(
  "subscriptionPlanModule/addSubscriptionPlanModule",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await addSubscriptionPlanModuleAPI(subscription);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding subscription plan module");
    }
  }
);

// Update Subscription
export const updateSubscriptionPlanModule = createAsyncThunk(
  "subscriptionPlanModule/updateSubscriptionPlanModule",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await updateSubscriptionPlanModuleAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating subscription plan module");
    }
  }
);

// Delete Subscription
export const deleteSubscriptionPlanModule = createAsyncThunk(
  "subscriptionPlanModule/deleteSubscriptionPlanModule",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await deleteSubscriptionPlanModuleAPI(subscription);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting subscription plan module");
    }
  }
);

// Active Deactive Subscription
export const activateDeactivateSubscriptionPlanModule = createAsyncThunk(
  "subscriptionPlanModule/activateDeactivateSubscriptionPlanModule",
  async (subscription, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateSubscriptionPlanModuleAPI(subscription);      
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating subscription plan module");
    }
  }
);